import React from 'react';

const services = [
    {
        id: 1,
        name: 'Basic Service',
        price: '$49.00',
        description: 'Perfect for everyday drivers who need quick answers. Get AI-powered diagnosis for common issues, service reminders, and basic maintenance guidance.',
        features: ['AI fault code explanations', 'Basic maintenance reminders', 'Cost estimates for common repairs', '1 vehicle'],
    },
    {
        id: 2,
        name: 'Intermediate Service',
        price: '$99.00',
        description: 'For drivers who want a deeper understanding of their vehicle. Includes full diagnostics history and step-by-step repair guidance.',
        features: ['Everything in Basic', 'Step-by-step repair guidance', 'Full service history log', 'Up to 2 vehicles'],
    },
    {
        id: 3,
        name: 'Advanced Service',
        price: '$199.00',
        description: 'Professional-grade vehicle intelligence for enthusiasts and DIYers. Advanced diagnostics, parts sourcing, and expert guidance all in one.',
        features: ['Everything in Intermediate', 'Advanced diagnostics reports', 'Parts sourcing assistance', 'Up to 3 vehicles'],
    },
    {
        id: 4,
        name: 'Advanced+ Service',
        price: '$249.00',
        description: 'The full CarFido experience. Unlimited vehicles, priority support, and access to all future features as they launch.',
        features: ['Everything in Advanced', 'Unlimited vehicles', 'Priority support', 'Early access to new features'],
    },
];

const ServicesPage = () => {
    return (
        <main className="font-nunito">

            {/* ===== HERO: Explore what we offer ===== */}
            {/* Full-width hero image at the top, then heading + subtext below on bg #eaeaea */}
            <section className="bg-[#F9F9F9]">
                {/* Full-width image banner */}
                <div className="w-full overflow-hidden" style={{ maxHeight: '400px' }}>
                    <img
                        src="/vehicle_app.png"
                        alt="Explore our services"
                        className="w-full h-full object-cover"
                        style={{ maxHeight: '400px' }}
                    />
                </div>

                {/* Heading + Subtext */}
                <div className="max-w-5xl mx-auto px-8 py-16 flex flex-col md:flex-row gap-12 items-start">
                    <div className="flex-1">
                        <h1 className="text-5xl md:text-6xl font-black text-black leading-tight">
                            Explore what we offer
                        </h1>
                    </div>
                    <div className="flex-1">
                        <p className="text-base text-black leading-relaxed">
                            Discover a refreshing take on technology services designed with you in mind. We're here to ensure your digital experience is as seamless and enjoyable as possible, always ready to lend a helping hand.
                        </p>
                    </div>
                </div>
            </section>

            {/* ===== SERVICE PRODUCTS GRID ===== */}
            {/* bg: #eaeaea, 2-column grid of product cards */}
            <section className="bg-[#F9F9F9] px-8 pb-24">
                <div className="max-w-5xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {services.map((service) => (
                            <div key={service.id} className="bg-[#fafafa] rounded-2xl overflow-hidden shadow-sm border border-black/5 hover:shadow-xl transition-all duration-300">
                                {/* Product image placeholder */}
                                <div className="bg-gray-100 w-full aspect-square flex items-center justify-center overflow-hidden">
                                    <img
                                        src="/vehicle_app.png"
                                        alt={service.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                {/* Product info */}
                                <div className="p-6">
                                    <div className="flex items-center justify-between mb-3">
                                        <h3 className="text-xl font-bold text-black">{service.name}</h3>
                                        <span className="text-lg font-bold text-black">{service.price}</span>
                                    </div>
                                    <p className="text-sm text-gray-700 mb-4 leading-relaxed">{service.description}</p>
                                    <ul className="space-y-1 mb-6">
                                        {service.features.map((f) => (
                                            <li key={f} className="text-sm text-black flex gap-2">
                                                <span className="text-green-600">✓</span>
                                                {f}
                                            </li>
                                        ))}
                                    </ul>
                                    <button className="w-full bg-black text-gray-100 font-bold py-3 rounded-full uppercase tracking-widest text-sm hover:opacity-80 transition-opacity">
                                        Book
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

        </main>
    );
};

export default ServicesPage;
